import { createNavigationItem, type NavigationGroupItem } from './side-nav-items';

export const MONITORING_GROUP_FEATURES = ['performance', 'leaderboards', 'inbox'] as const;

export type MonitorGroupFeature = (typeof MONITORING_GROUP_FEATURES)[number];

export const getMonitorGroupItems = (features: MonitorGroupFeature[]): NavigationGroupItem[] => {
  return features.map((f) => {
    switch (f) {
      case 'inbox':
        return createNavigationItem('inbox', '/monitoring/inbox', 'mail');
      case 'leaderboards':
        return createNavigationItem('leaderboards', '/monitoring/leaderboards', 'leaderboard');
      case 'performance':
        return createNavigationItem('reporting', '/monitoring/online-performance', 'timeline');
    }
  });
};
